import { render, staticRenderFns } from "./SchoolOrders.vue?vue&type=template&id=3ed0dd97&"
import script from "./SchoolOrders.vue?vue&type=script&lang=js&"
export * from "./SchoolOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports